import {
    AccessibilityClipFragment,
    AccessibilityVariantsFragment,
    AccessibilityTrailerFragment,
    AccessibilityVariantFragment,
} from 'app/graphql/__generated__/types/contento';
import React from 'react';
import VariantLink from './VariantLink';
import { StyledVariantLinkWrapper } from './VariantLinks.styles';

function isAccessibility(
    content: AccessibilityVariantsFragment
): content is AccessibilityVariantsFragment &
    (AccessibilityClipFragment | AccessibilityVariantFragment | AccessibilityTrailerFragment) {
    return (content as any).accessibility !== undefined;
}

export function isMainLanguage(
    content: AccessibilityVariantsFragment
): content is AccessibilityVariantsFragment & AccessibilityVariantFragment {
    return (content as any).mainLanguage !== undefined;
}

export const VariantLinks = ({
    selectedVideoId,
    context,
    onClick,
    videos,
    onlyAvailableInSweden = false,
}: {
    onClick: (accessibility: string) => void;
    videos: Array<AccessibilityVariantsFragment>;
    selectedVideoId: string;
    context: string;
    onlyAvailableInSweden?: boolean;
}) => {
    const variants = videos
        ?.filter(isAccessibility)
        .filter((video) => video.svtId && video.svtId !== selectedVideoId);

    if (!variants || variants.length === 0) {
        return null;
    }

    // "default" should be the last value in the array
    const sortedVariants = variants.sort((a, b) => (a.accessibility > b.accessibility ? 1 : -1));

    // used for text formatting swedish version when there are several language versions
    const hasMultipleLanguages =
        new Set(videos.filter(isMainLanguage).map((item) => item?.mainLanguage.name)).size > 1;

    return (
        <StyledVariantLinkWrapper context={context} onlyAvailableInSweden={onlyAvailableInSweden}>
            Finns även{' '}
            {sortedVariants.map((variant, i) => (
                <VariantLink
                    key={`variant-${i}`}
                    index={i}
                    variant={variant as AccessibilityVariantFragment}
                    onClick={onClick}
                    noOfVariants={variants.length}
                    hasMultipleLanguages={hasMultipleLanguages}
                    context={context}
                />
            ))}
        </StyledVariantLinkWrapper>
    );
};

export default VariantLinks;
